import { createSelector } from 'reselect';
import getMenuSectionsApi from '@core/reducers/menu/selectors/getMenuSections';
import getHighlightedProducts from '@core/reducers/menu/selectors/getHighlightedProducts';
import { getDiscountsProducts } from '@core/reducers/menu/selectors/getDiscountsProducts';
import {
  HIGHLIGHTED_PRODUCTS_SECTION_ID,
  DISCOUNTS_PRODUCTS_SECTION_ID,
  FAVORITES_DISHES_SECTION_ID,
} from '@shopDetails/constants';

const getMenuSections = createSelector(
  getMenuSectionsApi,
  getHighlightedProducts,
  getDiscountsProducts,
  (sections, highlightedProducts, discountsProducts) => {
    const extraSections = [];
    const [saveDishesSection, ...allSections] = sections;

    if (discountsProducts.length > 1) {
      extraSections.push({
        id: DISCOUNTS_PRODUCTS_SECTION_ID,
        name: 'Descuentos',
        products: discountsProducts,
      });
    }

    if (highlightedProducts.length > 0) {
      extraSections.push({
        id: HIGHLIGHTED_PRODUCTS_SECTION_ID,
        name: 'Recomendados',
        products: highlightedProducts,
      });
    }

    if (saveDishesSection?.id === FAVORITES_DISHES_SECTION_ID) {
      return [saveDishesSection, ...extraSections, ...allSections];
    }

    return [...extraSections, ...sections];
  },
);

export default getMenuSections;
